import React from 'react';
import propTypes from 'prop-types';
//import thumbnails from '../../data/thumbnails';

import './ReferenceImageBox.css';

// const getHeroImage = function(images) {
//   const defaultImage = '';
//   return ((images || []).filter(im => im.hero)[0] || (images || [])[0]) || defaultImage;
// }

const formatDate = function(dateString) {
  const options = { /*weekday: 'long',*/ year: 'numeric', month: '2-digit', day: '2-digit' };
  const date = new Date(dateString);

  return date.toLocaleDateString('en-GB', options);
}

const listCategories = function(categoriesArray) {
  return (categoriesArray || []).join(', ');
}

const ReferenceImageBox = props => (
  <a className={`ReferenceImageBox ${props.isLargeBox ? 'large' : 'small'}`} key={props._id || props.id} onClick={props.onClick.bind(this, props._id)}>
    <section className="ReferenceImageBox__wrapper">
      <section className={'ReferenceImageBox__progressBarContainer'}>
        <div className={'ReferenceImageBox__progressBar'} />
      </section>
      <img className={'ReferenceImageBox__image'} src={props.image} alt={props.title} />
      <section className={'ReferenceImageBox__itemTextArea'}>
        <section className="ReferenceImageBox__details">
          {props.categories && <section className="ReferenceImageBox__detailsCategories">{listCategories(props.categories)}</section>}
          {!props.categories && props.solutions && <section className="ReferenceImageBox__detailsSolutions">{listCategories(props.solutions)}</section>}
          {false && props.contentTypes && <section className="ReferenceImageBox__detailsContentTypes">{listCategories(props.contentTypes)}</section>}
          {props.date && <section className="ReferenceImageBox__detailsDate">{formatDate(props.date)}</section>}
        </section>
        <h4 className={'ReferenceImageBox__header'}>
          {props.projectName || props.title}
        </h4>
        <div className={'ReferenceImageBox__subheader'}>
          {props.tech}
        </div>
      </section>
    </section>
  </a>
);

export default ReferenceImageBox;

ReferenceImageBox.propTypes = {
  image: propTypes.string,
  title: propTypes.string,
  projectName: propTypes.string,
  tech: propTypes.string,
  categories: propTypes.array,
  contentTypes: propTypes.array,
  solutions: propTypes.array,
  // date: propTypes.string.isRequired,
  isLargeBox: propTypes.bool,
  onClick: propTypes.func.isRequired,
  _id: propTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/ReferenceImageBox/ReferenceImageBox.js